import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import UserProjectList from '@/components/UserProjectList.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectListView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, [
      _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'list'] }),
      _cache[0] || (_cache[0] = _createTextVNode(" Projects", -1))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("h5", null, "Upload FASTQs, analyze and inspect results", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", null, [
      _createTextVNode(" The "),
      _createElementVNode("strong", null, "Projects"),
      _createTextVNode(" view offers a seamless way to browse all your projects. You can upload data files in FASTQ format, with the option to upload compressed gzip files to save network bandwidth. You can manage and browse your files, initiate data analyses, and inspect the results directly within the platform. Premium users gain access to advanced analysis features, enhancing the research capabilities. All computations are performed using our cloud computational infrastructure, ensuring efficient and reliable processing of data. ")
    ], -1)),
    _createVNode(UserProjectList)
  ]))
}
}

})